module.exports = __webpack_public_path__ + "media/assets/images/plan03@2x-e3950c47cf2ea72d7882e2c63f2552c5.png";